<template>

  <div class="common-seach-wrap">
    <el-tabs v-model="actionName">
      <!-- <el-tab-pane label="授权证书" name="first"></el-tab-pane> -->
      <el-tab-pane label="证书设置" name="second"></el-tab-pane>
    </el-tabs>
    <!-- <Certificate v-if="actionName == 'first'"></Certificate> -->
    <!--基础设置-->
    <Setting v-if="actionName == 'second'"></Setting>
  </div>
</template>
<script>
import Certificate from './certificate/Certificate';
import Setting from './setting/Setting.vue';
export default {
  components: {
    Certificate,
    Setting,
  },
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      form: {
        status: 0
      },
      actionName: 'second'
    };
  },
  methods: {}
};
</script>

<style>
.operation-wrap {
  height: 124px;
  border-radius: 8px;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  padding: 30px 30px;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  overflow: hidden;
  background: #909399;
  background-size: 100% 100%;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/certificate/index.vue